import React from 'react';
import { useTranslation } from 'react-i18next';

import UniversalButton from "../../uiComponents/UniversalButton";

import "./ProofModal.scss";

const ProofModal = ({ children, proofCallback, cancelButtonText, proofButtonText, onCloseModal }) => {
  const { t } = useTranslation();

  return (
    <div className="proof-modal">
      <div className="proof-modal__header">{t('are_you_sure')}</div>
      <div className="proof-modal__text">{children}</div>

      <div className="radio-list-modal__btns">

        <div className="radio-list-modal__btns_btn">

          <UniversalButton
            type="button"
            label={cancelButtonText}
            size="lg"
            labelColor="blue"
            labelHoverColor="blue"
            backgroundColor="white"
            backgroundHoverColor="blue-light"
            onClick={onCloseModal}
          />
        </div>

        <UniversalButton
          type="button"
          label={proofButtonText}
          size="lg"
          labelColor="white"
          labelHoverColor="white"
          backgroundColor="orange"
          backgroundHoverColor="orange-light"
          onClick={proofCallback}
        />
      </div>
    </div>
  );
};

export default ProofModal;